export const ORDER_COUNTER = 1;

export const CUSTOM_DATA = {
    ORDER: 'order.confirmed',
    VERSION: 'release_version',
};
